<template>
    <div class="w-full h-[100vh] flex items-center justify-center">Halaman Tidak Ditemukan</div>
</template>
